var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsaapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4590_634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02418 23.7126C1.02305 27.7455 2.08505 31.6834 4.10443 35.1543L0.831055 47.0132L13.0621 43.8311C16.445 45.6585 20.2353 46.616 24.0871 46.6162H24.0972C36.8125 46.6162 47.1631 36.3496 47.1685 23.7306C47.1709 17.6158 44.7732 11.8659 40.4168 7.53994C36.0612 3.21436 30.2684 0.830916 24.0962 0.828125C11.3794 0.828125 1.02962 11.0942 1.02437 23.7126",
    fill: "url(#paint0_linear_4590_634)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.200625 23.7053C0.199313 27.8833 1.29937 31.962 3.39075 35.5572L0 47.8413L12.6696 44.5451C16.1604 46.4337 20.0908 47.4294 24.0902 47.4309H24.1005C37.272 47.4309 47.9944 36.795 48 23.7243C48.0023 17.3898 45.5182 11.4331 41.0062 6.95219C36.4937 2.47181 30.4937 0.00260465 24.1005 0C10.9267 0 0.205875 10.6344 0.200625 23.7053ZM7.74563 34.938L7.27256 34.1929C5.28394 31.0554 4.23431 27.4298 4.23581 23.7068C4.24012 12.8426 13.1509 4.00372 24.108 4.00372C29.4143 4.00595 34.401 6.05842 38.1517 9.78233C41.9023 13.5066 43.9661 18.4573 43.9648 23.7228C43.9599 34.587 35.049 43.427 24.1005 43.427H24.0926C20.5277 43.4251 17.0314 42.4752 13.9823 40.68L13.2566 40.253L5.73825 42.2089L7.74563 34.9379V34.938Z",
    fill: "url(#paint1_linear_4590_634)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1267 13.7954C17.6793 12.8088 17.2085 12.7889 16.7831 12.7716C16.4347 12.7567 16.0364 12.7578 15.6386 12.7578C15.2403 12.7578 14.5932 12.9065 14.0463 13.499C13.4988 14.0922 11.9561 15.5255 11.9561 18.4406C11.9561 21.356 14.096 24.1733 14.3943 24.569C14.693 24.964 18.5255 31.1377 24.5952 33.5128C29.6397 35.4866 30.6663 35.094 31.7611 34.995C32.8561 34.8964 35.2944 33.5621 35.7918 32.1785C36.2896 30.795 36.2896 29.6092 36.1404 29.3614C35.9911 29.1145 35.5929 28.9662 34.9957 28.67C34.3983 28.3736 31.4624 26.9402 30.9151 26.7424C30.3676 26.5448 29.9696 26.4462 29.5713 27.0395C29.1731 27.6319 28.0295 28.9662 27.6809 29.3614C27.3327 29.7575 26.9842 29.8068 26.3872 29.5104C25.7896 29.2131 23.8664 28.5882 21.5847 26.5697C19.8095 24.9991 18.611 23.0596 18.2626 22.4663C17.9142 21.8739 18.2253 21.5528 18.5247 21.2576C18.7931 20.9921 19.1221 20.5656 19.421 20.2198C19.7187 19.8737 19.8181 19.6269 20.0172 19.2317C20.2166 18.8362 20.1168 18.4901 19.9677 18.1937C19.8181 17.8974 18.6577 14.9669 18.1267 13.7954Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4590_634",
    x1: 2317.7,
    y1: 4619.34,
    x2: 2317.7,
    y2: 0.828125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4590_634",
    x1: 2400,
    y1: 4784.13,
    x2: 2400,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4590_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsaapIcon);
export default __webpack_public_path__ + "static/media/whatsaapIcon.2301c0586a51f5136b99c6159cb52c2d.svg";
export { ForwardRef as ReactComponent };